<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-0 mt-1">
      <b-btn block href="#" v-b-toggle.bondRemitHistory variant="info" class="text-left">Bond History</b-btn>
    </b-card-header>
    <b-collapse id="bondRemitHistory" visible>
      <b-card-body>
        <b-btn v-if="Object.keys(history).length == 0" variant="primary" @click="$emit('load')">Load Bond History</b-btn>
        <table class="table table-sm table-hover"  v-else>
            <caption class="table-caption text-left">{{getDealName()}}, History</caption>
            <thead>
              <th class="text-right sticky">Date</th>
              <th class="text-right sticky">Starting Balance</th>
              <th class="text-right sticky">Principal</th>
              <th class="text-right sticky">WriteDown</th>
              <th class="text-right sticky">Current Balance</th>
              <th class="text-right sticky">Factor</th>
              <th class="text-right sticky">Interest</th>
              <th class="text-right sticky">Couupon</th>
            </thead>
            <tbody>
              <tr v-for="row in history" :key=row.Date>
                <td class="text-right text-nowrap">{{row.Date}}</td>
                <td class="text-right">{{row.StartingBalance}}</td>
                <td class="text-right">{{row.Principal}}</td>
                <td class="text-right">{{row.WriteDown}}</td>
                <td class="text-right">{{row.CurrentBalance}}</td>
                <td class="text-right">{{row.Factor}}</td>
                <td class="text-right">{{row.Interest}}</td>
                <td class="text-right">{{row.Coupon}}</td>
              </tr>
            </tbody>
          </table>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    history: Array
  },
  methods: {
    getDealName() {
      return this.$store.getters.dealName;
    }
  }
}
</script>

